import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { urlJoin } from '../../../../core/helpers/url.helper';
import { AppConfig } from '../../../../app.config';
import { Observable } from 'rxjs';
import { DeliveryRequest, DeliveryResponse } from './demat-delivery/demat-delivery.component.model';
import { LogService } from '../../../../core/services/log/log.service';
import { createHeadersWithGlobalUuid } from '@tribeauto/ngx-mobilite-material';

@Injectable({
  providedIn: 'root'
})
export class DeliveryService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);
  private readonly logService = inject(LogService);

  private readonly url = urlJoin(this.appConfig.url, 'esign');

  getDeliveryDocESignatureURL(
    webstoreId: string,
    contractId: string,
    deliveryRequest: DeliveryRequest
  ): Observable<DeliveryResponse> {
    return this.httpClient.post<DeliveryResponse>(
      urlJoin(this.url, `webstores/${webstoreId}/contracts/${contractId}/deliveryDoc`),
      deliveryRequest,
      { headers: createHeadersWithGlobalUuid(this.logService.sessionUuid()) }
    );
  }
}
